/* eslint-disable indent */
import React, { useEffect } from "react";
import styles from "../EditableTag.module.css";
import { useEditableTag } from "./EditableTagBase";
import { ToolbarComponent, CanvasComponent } from "./SharedComponents";

const EditableTag3x3 = ({ initialData, doubleTag = false }) => {
	// Tamanho 3x3 cm = ~85x85 pixels (aproximadamente 28 pixels por cm)
	const canvasSize = { width: 75.59, height: 75.59 };
	const {
		canvasRef,
		elements,
		setElements,
		setInitialElements,
		selectedElement,
		setSelectedElement,
		zoom,
		handleMouseDown,
		handleElementClick,
		handleMouseMove,
		handleMouseUp,
		updateElementProperty,
		deleteElement,
		handleZoomIn,
		handleZoomOut,
		handleZoomReset,
		exportToPDF,
		printPDF,
		resetToInitialState
	} = useEditableTag(canvasSize);

	useEffect(() => {
		if (initialData)
			initializeElements(initialData);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialData]);

	const initializeElements = (data) => {
		const newElements = [];
		let idCounter = Date.now();

		// Layout 3x3: centralizado e minimalista como PdfQronly
		// Texto superior "CONHEÇA A ORIGEM"
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "CONHEÇA A ORIGEM",
			x: 5,
			y: 5,
			width: canvasSize.width - 10,
			height: 6,
			fontSize: 4,
			fontWeight: "normal",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		// Texto "DO PRODUTO"
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "DO PRODUTO",
			x: 5,
			y: 10,
			width: canvasSize.width - 10,
			height: 6,
			fontSize: 4,
			fontWeight: "normal",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		// QR Code centralizado
		if (data.qrCode) {
			const qrSize = 50;
			const qrX = (canvasSize.width - qrSize) / 2;
			const qrY = 18;

			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.qrCode,
				x: qrX,
				y: qrY,
				width: qrSize,
				height: qrSize
			});
		}

		// Texto inferior "SISAGRI"
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "SISAGRI",
			x: 5,
			y: 69,
			width: canvasSize.width - 10,
			height: 6,
			fontSize: 4,
			fontWeight: "normal",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		setElements(newElements);
		setInitialElements(JSON.parse(JSON.stringify(newElements)));
	};

	const selectedElementData = elements.find(el => el.id === selectedElement);

	return (
		<div className={styles.editorContainer}>
			<ToolbarComponent
				selectedElementData={selectedElementData}
				updateElementProperty={updateElementProperty}
				handleZoomOut={handleZoomOut}
				handleZoomIn={handleZoomIn}
				handleZoomReset={handleZoomReset}
				zoom={zoom}
				exportToPDF={() => exportToPDF("3x3", doubleTag)}
				printPDF={() => printPDF(doubleTag)}
				resetToInitialState={resetToInitialState}
			/>

			<CanvasComponent
				canvasRef={canvasRef}
				canvasSize={canvasSize}
				zoom={zoom}
				elements={elements}
				selectedElement={selectedElement}
				setSelectedElement={setSelectedElement}
				handleMouseMove={handleMouseMove}
				handleMouseUp={handleMouseUp}
				handleMouseDown={handleMouseDown}
				handleElementClick={handleElementClick}
				deleteElement={deleteElement}
			/>
		</div>
	);
};

export default EditableTag3x3;
